import script from "./Secret.vue?vue&type=script&setup=true&lang=js"
export * from "./Secret.vue?vue&type=script&setup=true&lang=js"

import "./Secret.vue?vue&type=style&index=0&id=5cde7587&lang=css"

const __exports__ = script;

export default __exports__